export default "__VITE_ASSET__9a6624c8__"